import { render, staticRenderFns } from "./SessionViewAddStudent.vue?vue&type=template&id=44467736&"
import script from "./SessionViewAddStudent.vue?vue&type=script&lang=js&"
export * from "./SessionViewAddStudent.vue?vue&type=script&lang=js&"
import style0 from "./SessionViewAddStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports